module.exports = __webpack_public_path__ + "static/fonts/Montserrat-MediumItalic.40a7470.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Montserrat-MediumItalic.ttf
// module id = J/hf
// module chunks = 1